import React from 'react';
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectProps, Typography } from '@mui/material';

import { LocalizationContext } from '@cvt/contexts';


export type PetTypeSelectProps = Omit<SelectProps<string | null>, 'renderValue'> & {
  error?: boolean;
  helperText?: React.ReactNode;
};

export const PetTypeSelect = React.forwardRef<HTMLDivElement, PetTypeSelectProps>(({ error, helperText, label, slotProps, ...props }, ref) => {

  const { dictionary } = React.useContext(LocalizationContext);
  const petTypes = React.useMemo(() => {
    return [
      'dog', 'cat', 'bird', 'rabbit', 'fish', 'reptile', 'horse', 'other',
    ];
  },[]);

  return (
    <Box width="100%">
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          displayEmpty
          label={label}
          {...props}
          ref={ref}
          color="primary"
          renderValue={(selected) => {
            const petType = petTypes.find((petType) => petType === selected);
            if (!petType) {
              return (
                <span style={{ color: '#a2a2a2' }}>
                  {dictionary.forms.tributes.petTypePlaceholder}
                </span>
              );
            }
            return (
              <Typography sx={{ textTransform: 'capitalize' }}>{petType}</Typography>
            );
          }}
          MenuProps={{
            ...props.MenuProps,
            PaperProps: {
              ...props.MenuProps?.PaperProps,
              sx: {
                maxHeight: (36 * 8.5) + 8,
              },
            },
          }}
          error={error}
        >
          <MenuItem value="">
            <span style={{ color: '#a2a2a2' }}>
              {dictionary.forms.tributes.petTypePlaceholder}
            </span>
          </MenuItem>
          {petTypes.map((petType) => (
            <MenuItem key={petType} value={petType}  sx={{ textTransform: 'capitalize' }}>
              {petType}
            </MenuItem>
          ))}
        </Select>
        {!!helperText && (
          <FormHelperText error={error}>{helperText}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
});
